<template>
  <div>
    <header-title
      title="الفعاليات"
      titlePrevious="الرئيسية"
      color="#82868b"
      :isNgo="true"
    />
    <div class="container pb-1 mt-2">
      <div class="shadow">
        <div class="p-2 m-auto bg-white rounded d-flex">
          <div
            v-for="d in dateSelect"
            :key="d.id"
            style="
              margin-left: 20px;
              margin-right: 20px;
              padding-bottom: 10px;
              cursor: pointer;
            "
            :class="{ selectedDate: d.id === selectedDay }"
            @click="changeDate(d.id)"
          >
            {{ d.date }}
          </div>
        </div>
        <div class="sidebar">
          <div
            class="d-flex small_header p-2 m-auto justify-content-between align-items-center bg-white"
          >
            <div class="d-flex w-100 align-items-center flex-wrap">
              <!--  -->
              <form-mask
                options="date"
                placeholder="YYYY-MM-DD"
                id="employment_date"
                v-model="selectedDate"
                rules="required"
                style="height: 37.5px !important"
                class="w-25"
              />
            </div>

            <div class="px-1 d-flex justify-content-end" style="width: 300px">
              <b-button
                :disabled="loading"
                variant="info"
                class="mx-1"
                @click="fliterByParam()"
                >بحث</b-button
              >
              <b-button variant="primary" @click="unFilter()"
                >إلغاء البحث</b-button
              >
            </div>
          </div>
        </div>
      </div>
      <filter-events></filter-events>
      
      <div style="margin-top: 20px; width: 100%">
        <div v-if="loading" class="row" style="min-height: 500px">
          <skeleton class="col-lg-4 col-md-6 col-12" v-for="n in 3" :key="n">
          </skeleton>
        </div>

        <div class="my-1" v-else-if="!loading && activities.length == 0">
          <!-- <not-item :massage="$t('alert')"></not-item> -->
          <alert :massage="$t('alert')" class="w-100"></alert>
        </div>
        <div class="row" v-else>
          <div
            v-for="(item, i) in activities"
            :key="i"
            class="col-lg-4 col-md-6 col-12"
            @click="
              () => {
                activ = true;
                changeDataDialog(item);
              }
            "
          >
            <card-activites :info="item" :activ="activ"></card-activites>
          </div>
        </div>
      </div>
      <activities-dialog
        v-model="activ"
        :dataDialog="dataDialog"
      ></activities-dialog>
      <pagination
        v-model="currentPage"
        :total-rows="pagination.total_rows"
        :per-page="pagination.per_page"
        align="center"
        class="mb-2"
      >
      </pagination>
    </div>
  </div>
</template>

<script>
import CardActivites from "../../components/CardActivites.vue";
import ActivitiesDialog from "../../components/ActivitiesDialog.vue";
import Skeleton from "../../components/Skeleton.vue";
import HeaderTitle from "../../components/HeaderTitle.vue";
import formAutocomplete from "@/components/form-autocomplete";
import formSelect from "@/components/form-select";
import FilterEvents from "../../components/FilterEvents.vue";
import FormSelect from "@/components/form-select/index.vue";
import FormMask from "@/components/form-mask";
import {
  BDropdown,
  BFormGroup,
  BDropdownItem,
  BDropdownDivider,
  BPagination,
  BFormDatepicker,
  BButton,
  BPaginationNav,
} from "bootstrap-vue";
import NotItem from "../../components/NotItem.vue";
import { mapGetters } from "vuex";
import Alert from "@/components/Alert";
import vSelect from "vue-select";
import Pagination from "@/components/pagination/index.vue";
import FormDatepicker from "@/components/form-datepicker/index.vue";
export default {
  components: {
    formAutocomplete,
    formSelect,
    BPagination,
    CardActivites,
    ActivitiesDialog,
    vSelect,
    BDropdown,
    BFormGroup,
    BDropdownItem,
    BDropdownDivider,
    Skeleton,
    NotItem,
    BFormDatepicker,
    HeaderTitle,
    BButton,
    FilterEvents,
    Alert,
    BPaginationNav,
    FormSelect,
    Pagination,
    FormDatepicker,
    FormMask,
  },

  data() {
    return {
      currentPage: 1,
      activ: false,
      dataDialog: {
        dispatch: "",
        from_event_date: "",
        to_event_date: "",
        location: "",
        ngo: { name_ar: "" },
      },

      selectedDay: null,
      selectedOrg: "",
      selectedType: null,
      selectedDate: null,

      value: "",
      dateSelect: [
        { date: "الكل", id: "" },
        { date: " اليوم", id: "day" },
        { date: "الأسبوع القادم", id: "week" },
        { date: " الشهر القادم", id: "month" },
      ],
    };
  },
  methods: {
    onContext(ctx) {
      this.value = ctx.selectedFormatted;
    },
    unFilter() {
      this.currentPage = 1;
      this.selectedDate = "";
      this.selectedOrg = "";
      this.selectedType = "";
      this.selectedDay = "";
      this.fliterByParam();
    },
    dateDisabled(ymd, date) {
      const weekday = date.getDay();
      const day = date.getDate();
      return weekday === 0 || weekday === 6 || day === 13;
    },
    changeDate(date) {
      this.selectedDay = date;
    },
    changeDataDialog(data) {
      this.dataDialog = data;
    },
    fliterByParam() {
      this.currentPage = 1;
      this.$store.dispatch("NgoHome/activites_/getSlids", {
        filter_date: this.selectedDay,
        ngo_id: this.$route.params.id,
        event_type_id: 3,
        time: this.selectedDate,
      });
    },
  },
  computed: {
    ...mapGetters("NgoHome/activites_", [
      "activities",
      "loading",
      "pagination",
    ]),
  },
  watch: {
    selectedDay(value) {
      this.fliterByParam();
    },
    currentPage(value) {
      this.$store.dispatch("NgoHome/activites_/getSlids", {
        filter_date: this.selectedDay,
        page: value,
        filter_date: this.selectedDay,
        ngo_id: this.$route.params.id,
        event_type_id: 3,
        time: this.selectedDate,
      });
    },
  },
  created() {
    this.$store.dispatch("NgoHome/activites_/getSlids", {
      filter_date: this.selectedDay,
      ngo_id: this.$route.params.id,
      event_type_id: 3,
      time: this.selectedDate,
    });
  },
};
</script>

<style lang="scss">
.dropdown-menu {
  width: 290px;
}
.selectedDate {
  border-bottom: 3px solid #048042;
}

.arrow_left {
  .dropdown-toggle::after {
    transform: translate(60px, -5px);
  }
}

@media (max-width: 500px) {
  .small_header {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
}

@media (max-width: 1030px) {
  .sidebar {
    display: none;
  }
}
</style>
